export const DEFAULT_METRICS_EXPORT_INTERVAL_MILLIS = 10000;
